import { FC } from "react";
import styles from "./ExitPopup.module.scss";
import warningIcon from "../../../icons/warn.png";

interface IExitPopupProps {
    onClose: () => void;
    onCancel: () => void;
    title: string;
    description?: string;
}

export const ExitPopup: FC<IExitPopupProps> = ({ title, description, onClose, onCancel }) => {
    return (
        <div className={styles.popup}>
            <div className={styles.contentWrapper}>
                <img
                    src={warningIcon}
                    alt="Иконка"
                    className={styles.icon}
                />

                <h2>{ title }</h2>
                { description && <p>{ description }</p> }

                <button className={styles.closeButton} onClick={onClose}>
                    Выход
                </button>

                <button className={styles.cancelButton} onClick={onCancel}>
                    Отмена
                </button>
            </div>
        </div>
    );
};